<template>
  <div>
    <form class="action-buttons-fixed" @submit.prevent="handleSubmit">
      <div class="row">
        <div class="col">
          <section class="card card-modern card-big-info">
            <div class="card-body">
              <div class="row">
                <div class="col-lg-2-5 col-xl-1-5">
                  <i class="card-big-info-icon bx bx-user"></i>
                  <h2 class="card-big-info-title">Uloge</h2>
                  <p class="card-big-info-desc">Definirajte uloge korisnika.</p>
                </div>
                  <div class="col-lg-3-5 col-xl-4-5">
                    <div class="form-group row align-items-center mb-3">
                      <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">
                        Naziv uloge
                      </label>
                      <div class="col-lg-7 col-xl-8">
                        <input
                          type="text"
                          class="form-control form-control-modern"
                          v-model="name"
                        />
                      </div>
                    </div>

                    <div class="form-group row align-items-center mb-3">
                      <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">
                        Opis
                      </label>
                      <div class="col-lg-7 col-xl-8">
                        <textarea class="form-control" rows="3" v-model="description"></textarea>
                      </div>
                    </div>

                    <div class="form-group row mb-3">
                      <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">
                        Dozvoljene ekstenzije
                      </label>
                      <div class="col-lg-7 col-xl-8">
                        <treeselect
                          v-model="allowedDocumentExtensionIds"
                          :multiple="true"
                          :options="allowedDocumentExtensions"
                          placeholder="Izaberite dozvoljene ekstenzije"
                        />
                      </div>
                    </div>

                    <div class="form-group row align-items-center pb-3">
                      <label
                        class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >
                        Vidi zaštićene dokumenate?
                      </label>
                      <div class="col-lg-7 col-xl-6">
                        <div class="checkbox-custom checkbox-default">
                          <input
                            type="checkbox"
                            v-model="canSeeProtectedFiles"
                            id="can-see-protected-files"
                          />
                          <label for="can-see-protected-files"></label>
                        </div>
                      </div>
                    </div>

                    <div class="form-group row align-items-center role">
                      <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">
                        Dozvole
                      </label>
                      <div class="col-lg-7 col-xl-8">
                        <div class="permissions-wrapper">
                          <div class="checkbox-custom checkbox-default checkbox-permission all-permissions">
                            <input
                              @click="checkAllPermissions"
                              type="checkbox"
                              id="all-permissions"
                              :checked="isAllPermissionsChecked"
                            />
                            <label for="all-permissions">Označi sve</label>
                          </div>

                          <div
                            class="checkbox-custom checkbox-default checkbox-permission"
                            v-for="item in permissions"
                            :key="item.id"
                          >
                            <input
                              type="checkbox"
                              :id="`checkbox-${item.id}`"
                              :value="item.id"
                              v-model="permissionIds"
                            />
                            <label :for="`checkbox-${item.id}`">{{ item.label }}</label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
              </div>
            </div>
          </section>
        </div>
      </div>

      <div
        class="action-buttons d-flex justify-content-between"
        style="margin-top: 2rem"
      >
        <div>
          <button
            type="button"
            data-bs-toggle="modal"
            data-bs-target="#delete-modal"
            class="
              delete-button
              btn btn-danger btn-px-4
              py-3
              d-flex
              align-items-center
              font-weight-semibold
              line-height-1
            "
          >
            <i class="bx bx-trash text-4 me-2"></i> Izbriši
          </button>
        </div>
        <div class="d-flex gap-3">
          <router-link
            :to="{ name: 'UserRoles' }"
            exact
            class="
              cancel-button
              btn btn-light btn-px-4
              py-3
              border
              font-weight-semibold
              text-color-dark text-3
            "
          >
            Otkaži
          </router-link>
          <button
            type="submit"
            class="
              submit-button
              btn btn-primary btn-px-4
              py-3
              d-flex
              align-items-center
              font-weight-semibold
              line-height-1
            "
          >
            <i class="bx bx-save text-4 me-2"></i> Sačuvaj
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import Vue from 'vue';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

import api from '@/services/api';

export default {
  name: 'AddUserRole',
  components: {
    Treeselect,
  },
  data() {
    return {
      permissionIds: [],
      name: '',
      description: '',
      canSeeProtectedFiles: false,
      allowedDocumentExtensionIds: [],
    };
  },
  computed: {
    permissions() {
      return this.$store.getters.getPermissions.map(({ id, title }) => {
        return {
          label: title,
          id: id,
        };
      });
    },
    isAllPermissionsChecked() {
      return this.permissions?.length === this.permissionIds.length;
    },
    allowedDocumentExtensions() {
      return this.$store.getters.getAllowedDocumentExtensions;
    },
  },
  methods: {
    handleSubmit() {
      const { permissionIds, name, description, allowedDocumentExtensionIds, canSeeProtectedFiles } = this;
      const payload = {
        permissions: permissionIds,
        name,
        description,
        allowedDocumentExtensionIds,
        canSeeProtectedFiles
      };
      api.createRole(payload).then((response) => {
        this.$toast.info(response.data.info);
        this.$router.push({ name: 'UserRoles' });
      }).catch((err) => {
        this.$toast.error(err.response.data.info);
      });
    },
    checkAllPermissions() {
      if (this.permissions.length === this.permissionIds.length) {
        Vue.nextTick(() => {
          this.permissionIds = [];
        });
      } else {
        Vue.nextTick(() => {
          this.permissionIds = this.permissions.filter((i) => i.id !== 0).map((i) => i.id);
        });
      }
    },
  },
  mounted() {
    this.$store.dispatch('getPermissions');
    this.$store.dispatch('getAllowedDocumentExtensions');
  },
};
</script>
<style lang="scss" scoped>
.checkbox-permission {
  --checked-permission-bg: #2b90d9;

  padding: 0.75rem;
  margin-bottom: 0;

  input[type="checkbox"] {
    margin: 1rem;

    &:checked {
      + label:after {
        left: 12px;
        color: #fff;
      }

      + label:before {
        border: 2px solid var(--checked-permission-bg);
        border-radius: 2px;
        background: var(--checked-permission-bg);
        color: #fff;
        margin-top: -9px;
        overflow: hidden;
        height: 19px;
        font-size: 12px;
      }
    }
  }

  label {
    display: block;
    padding-inline: 1.5rem;

    &:before {
      margin-left: 0.5rem;
    }
  }
}
.all-permissions {
  background: #eee;
}

.permissions-wrapper {
  max-height: calc(100vh - 550px);
  overflow: auto;
  border: 1px solid #eee;
}

section {
  height: calc(100vh - 200px);
}
</style>
